import { useSuspenseQuery } from "@apollo/client";

const HumanReadableProperty = (props) => {
  const { data } = useSuspenseQuery(props.payload.query, props.payload.config);

  return <>{props.getValue(data)}</>;
};

export default HumanReadableProperty;
